export const PersistentStoreName = {
  API_REQUEST_QUEUE_STORE: 'apiRequestQueueStore',
  CONTACTS_AND_GROUPS_STORE: 'contactsAndGroupsStore',
  DETAILS_PANEL_STORE: 'detailsPanelStore',
  EQUIPMENT_STATUS_PANEL_STORE: 'equipmentStatusPanelStore',
  FEEDBACK_EVENT_STORE: 'feedbackEventStore',
  FIELD_ASSETS_STORE: 'fieldAssetsStore',
  INTERCOM_STORE: 'intercomStore',
  LAYERS_NAVIGATION_MENU_STORE: 'layersNavigationMenuStore',
  MAP_CONTROLS_STORE: 'mapControlsStore',
  MAP_SEARCH_STORE: 'mapSearchStore',
  MAP_SELECTED_CARD_STORE: 'mapSelectedCardStore',
  MAP_STORE: 'mapStore',
  NETWORK_STORE: 'networkStore',
  SELECTED_FIELD_ASSETS_STORE: 'selectedFieldAssetsStore',
  SELECTED_VALUE_GROUPS_STORE: 'selectedValueGroupsStore',
  SERVICE_CENTER_STORE: 'serviceCenterStore',
  SMALL_STORE: 'smallStore',
  USER_DETAILS_STORE: 'userDetailsStore',
} as const

export type TPersistentStoreName = (typeof PersistentStoreName)[keyof typeof PersistentStoreName]

export const STORES_TO_NOT_RESET_UNLESS_IN_CLEANUP_MAP: TPersistentStoreName[] = [
  PersistentStoreName.DETAILS_PANEL_STORE,
  PersistentStoreName.LAYERS_NAVIGATION_MENU_STORE,
  PersistentStoreName.MAP_CONTROLS_STORE,
  PersistentStoreName.MAP_SEARCH_STORE,
  PersistentStoreName.MAP_SELECTED_CARD_STORE,
  PersistentStoreName.MAP_STORE,
  PersistentStoreName.SELECTED_FIELD_ASSETS_STORE,
  PersistentStoreName.SELECTED_VALUE_GROUPS_STORE,
  PersistentStoreName.SMALL_STORE,
]

export type TPersistentStoreOverrides = Partial<Record<TPersistentStoreName, true | string[]>>

type TStoreKeyCleanupMap = Record<string, TPersistentStoreOverrides>

export const PERSISTENCE_STORES_CLEANUP_MAP: TStoreKeyCleanupMap = {
  /**
   * This map is for the stores in STORES_TO_NOT_RESET_UNLESS_IN_CLEANUP_MAP.
   * If the store has structural changes and needs to reset on an app version change,
   * add it here in the following format with the upcoming new release version.
   */
  // '0.0.0': {
  //   [PersistentStoreName.VALID_KEY_NAME]: true, // clear full store
  // },
}
